/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coach_Manage_Rename_ActionInputs */

const en_us2_coach_manage_rename_action = /** @type {(inputs: Coach_Manage_Rename_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rename`)
};

const pt_br2_coach_manage_rename_action = /** @type {(inputs: Coach_Manage_Rename_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Renomear`)
};

const es_419_coach_manage_rename_action = /** @type {(inputs: Coach_Manage_Rename_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Renombrar`)
};

const pt_pt2_coach_manage_rename_action = /** @type {(inputs: Coach_Manage_Rename_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mudar o nome`)
};

const fr_fr2_coach_manage_rename_action = /** @type {(inputs: Coach_Manage_Rename_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Renommer`)
};

const de_de2_coach_manage_rename_action = /** @type {(inputs: Coach_Manage_Rename_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Umbenennen`)
};

const it_it2_coach_manage_rename_action = /** @type {(inputs: Coach_Manage_Rename_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rinomina`)
};

/**
* | output |
* | --- |
* | "Rename" |
*
* @param {Coach_Manage_Rename_ActionInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const coach_manage_rename_action = /** @type {((inputs?: Coach_Manage_Rename_ActionInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coach_Manage_Rename_ActionInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_coach_manage_rename_action(inputs)
	if (locale === "es-419") return es_419_coach_manage_rename_action(inputs)
	if (locale === "pt-PT") return pt_pt2_coach_manage_rename_action(inputs)
	if (locale === "fr-FR") return fr_fr2_coach_manage_rename_action(inputs)
	if (locale === "de-DE") return de_de2_coach_manage_rename_action(inputs)
	if (locale === "it-IT") return it_it2_coach_manage_rename_action(inputs)
	return en_us2_coach_manage_rename_action(inputs)
});
export { coach_manage_rename_action as "coach-manage.rename_action" }